import {
  MAX_PRODUCT_DESCRIPTION_LENGTH,
  MAX_PRODUCT_NAME_LENGTH,
  MAX_PRODUCT_PRICE_RANGE_LENGTH,
} from './productLimits';
import { MAX_PRODUCT_ALIAS_LENGTH, MAX_PRODUCT_ALIASES } from './productNaming';

const ERROR_KEY_PREFIX = 'onboardingWizard.products.errors.';

export const PRODUCT_GENERIC_ERROR_KEY = 'settings.businessContext.products.saveError';

const KNOWN_PRODUCT_ERROR_CODES = new Set([
  'product_name_taken',
  'product_name_required',
  'product_name_invalid',
  'product_name_too_long',
  'product_alias_invalid',
  'product_alias_too_long',
  'product_aliases_too_many',
  'product_description_too_long',
  'product_price_range_too_long',
]);

export const productErrorMessageKey = (error: unknown): string => {
  const code = (error as { response?: { data?: { errorCode?: unknown } } } | undefined)?.response
    ?.data?.errorCode;

  return typeof code === 'string' && KNOWN_PRODUCT_ERROR_CODES.has(code)
    ? `${ERROR_KEY_PREFIX}${code}`
    : PRODUCT_GENERIC_ERROR_KEY;
};

const ERROR_LIMITS: Record<string, number> = {
  product_name_too_long: MAX_PRODUCT_NAME_LENGTH,
  product_alias_too_long: MAX_PRODUCT_ALIAS_LENGTH,
  product_aliases_too_many: MAX_PRODUCT_ALIASES,
  product_description_too_long: MAX_PRODUCT_DESCRIPTION_LENGTH,
  product_price_range_too_long: MAX_PRODUCT_PRICE_RANGE_LENGTH,
};

export const productErrorMessageParams = (messageKey: string): { max: number } | undefined => {
  const max = ERROR_LIMITS[messageKey.slice(ERROR_KEY_PREFIX.length)];
  return messageKey.startsWith(ERROR_KEY_PREFIX) && max !== undefined ? { max } : undefined;
};
